import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Reports/shared/ReportStateBadge.tsx
function ReportStateBadge({ state }) {
	switch (state) {
		case "closed": return /* @__PURE__ */ jsx("span", {
			className: "badge badge-neutral",
			children: "Closed"
		});
		case "open": return /* @__PURE__ */ jsx("span", {
			className: "badge badge-info",
			children: "Open"
		});
		case "review": return /* @__PURE__ */ jsx("span", {
			className: "badge badge-positive",
			children: "Review"
		});
		default: return null;
	}
}
//#endregion
export { ReportStateBadge };

//# sourceMappingURL=ReportStateBadge.js.map